import { useEffect, Suspense } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

function RedirectHandler() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const to = searchParams.get('to');
  
  useEffect(() => {
    if (to) {
      navigate(`/b?p=${to}`, { replace: true });
    }
  }, [to, navigate]);
  
  return (
    <div className="min-h-screen bg-grey-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-300 mx-auto"></div>
        <p className="mt-4 text-grey-600">Redirecting...</p>
      </div>
    </div>
  );
}

export default function RedirectPage() {
  return (
    <Suspense fallback={
      <div className="min-h-screen bg-grey-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-300"></div>
      </div>
    }>
      <RedirectHandler />
    </Suspense>
  );
}